<div *ngIf="images?.length">
  <keen-instance
    [overlayImage]="overlayImage"
    [images]="images"
    *ngIf="images.length"
  ></keen-instance>
</div>
